import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

function loadLocaleMessages() {
  const messages = {};
  const localeIdentifier = process.env.VUE_APP_I18N_LOCALE_IDENTIFIER || '_default';

  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);

  locales.keys().forEach((key) => {
    const matched = key.match(/([a-z0-9]+)\./i);
    const regExp = new RegExp(`${localeIdentifier}`);
    const localeIdentifierMatched = regExp.test(key);
    if (matched && matched.length > 1 && localeIdentifierMatched) { 
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages(),
});
